import { render, staticRenderFns } from "./invoiceaddress.vue?vue&type=template&id=16b94af7&scoped=true"
import script from "./invoiceaddress.vue?vue&type=script&lang=js"
export * from "./invoiceaddress.vue?vue&type=script&lang=js"
import style0 from "./invoiceaddress.vue?vue&type=style&index=0&id=16b94af7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b94af7",
  null
  
)

export default component.exports